import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import InsideHeader from "../../../components/InsideHeader";
import { setFolderObj } from "../../../features/folder/folderSlice";
import DeleteModal from "../../../components/DeleteModal";
import TableLoading from "../../../components/TableLoading";
import {
  fetchStoreItem,
  fetchStoreRequest,
} from "../../../features/dropdown/dropdownSlice";
import { deleteStoreRequest } from "../../../features/staff-setting/staffSettingSlice";
import Search from "../../../components/Search";
import { cashConverter } from "../../../utils";
import AddStoreRequestModal from "./modal/AddStoreRequestModal";
import { save } from "../../../features/save/saveSlice";
import ConfirmSubmitModal from "../../../components/ConfirmSubmitModal";

export default function StoreRequestTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { storeRequestData, loading, storeRequestCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);
  const { saving } = useSelector((state) => state.save);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
  };

  const filterDataList = searchInput
    ? storeRequestData?.filter((item) =>
        item?.srItemName?.toLowerCase().includes(searchInput.toLowerCase())
      )
    : storeRequestData;

  async function handleAdd() {
    await setProdd("");
    await setopen(true);
  }
  const [activeBtn, setActiveBtn] = useState(null);

  const handleClick = async (item) => {
    await setActiveBtn(item);
  };

  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const handleConfirmation = async () => {
    await setIsModalOpenSubmit(true);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteStoreRequest({
        srId: prodd?.srId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchStoreRequestData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleEdit = () => {
    setopen(true);
  };

  const handleView = async () => {
    await dispatch(setFolderObj(prodd));
    await navigate("/store-request-details");
  };
  const handlePostRequest = async () => {
    const res = await dispatch(
      save({
        url: `asset/postStoreRequest.action?srId=${prodd?.srId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchStoreRequestData();
      await setIsModalOpenSubmit(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
  const settingItems = [
    {
      key: "3",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Details
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          onClick={prodd?.srStatus === "POSTED" ? null : handleConfirmation}
          className={`flex  text-[16px] font-sans  !text-lightBlack ${
            prodd?.srStatus === "POSTED"
              ? "cursor-not-allowed"
              : "cursor-pointer"
          }`}
        >
          Post Store Request
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Delete
        </Link>
      ),
    },
  ];

  const columns = [
    
    {
      title: "Description",
      dataIndex: "srDescription",
      sorter: (a, b) => a.srDescription.localeCompare(b.srDescription),
    },
    {
      title: "Quantity",
      dataIndex: "srQuantity",
      sorter: (a, b) => a.srQuantity - b.srQuantity,
    },
    {
      title: "Unit Cost",
      dataIndex: "srUnitCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.srUnitCost - b.srUnitCost,
    },
    {
      title: "Total Cost",
      dataIndex: "srTotalCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.srTotalCost - b.srTotalCost,
    },
    {
      title: "Serial Number",
      dataIndex: "srNo",
      sorter: (a, b) => a.srNo.localeCompare(b.srNo),
    },
    {
      title: "Status",
      dataIndex: "srStatus",
      render: (item) => {
        const colors = {
          POSTED: "#2DD683",
          OPEN: "#FFAB00",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];
  async function fetchStoreItemData() {
    dispatch(fetchStoreItem());
  }

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchStoreRequestData(page, size) {
    dispatch(
      fetchStoreRequest({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        srStatus:activeBtn
      })
    );
  }

  useEffect(() => {
    fetchStoreRequestData();
    fetchStoreItemData();
  }, []);

  if (loading) return <TableLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Store Request Information"
        subtitle="Manage Store Requests within your institution"
        back={false}
      />
      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Store Request Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="w-[16.8125rem] lg:mt-0 mt-3">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search Store Request..."}
              />
            </div>

            <div className="w-[250px]">
              <button onClick={() => handleAdd()} className="cstm-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M19.5 11H13.5V5C13.5 4.73478 13.3946 4.48043 13.2071 4.29289C13.0196 4.10536 12.7652 4 12.5 4C12.2348 4 11.9804 4.10536 11.7929 4.29289C11.6054 4.48043 11.5 4.73478 11.5 5V11H5.5C5.23478 11 4.98043 11.1054 4.79289 11.2929C4.60536 11.4804 4.5 11.7348 4.5 12C4.5 12.2652 4.60536 12.5196 4.79289 12.7071C4.98043 12.8946 5.23478 13 5.5 13H11.5V19C11.5 19.2652 11.6054 19.5196 11.7929 19.7071C11.9804 19.8946 12.2348 20 12.5 20C12.7652 20 13.0196 19.8946 13.2071 19.7071C13.3946 19.5196 13.5 19.2652 13.5 19V13H19.5C19.7652 13 20.0196 12.8946 20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929C20.0196 11.1054 19.7652 11 19.5 11Z"
                    fill="#FFCD47"
                  />
                </svg>
                <span className="ml-1">Add Store Request</span>
              </button>
            </div>
          </div>
          <div className="flex items-center gap-x-14 mb-2 mt-5 w-auto p-1.5">
                <button
                  onClick={() => handleClick(null)}
                  className={`${
                    activeBtn === null
                      ? "text-[#146ADC] border border-[#146ADC]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#146ADC]"></span>{" "}
                  All
                </button>
                <button
                  onClick={() => handleClick("OPEN")}
                  className={`${
                    activeBtn === "OPEN"
                      ? "text-[#FFAB00] border border-[#FFAB00]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#FFAB00]"></span>{" "}
                  Open
                </button>
                <button
                  onClick={() => handleClick("POSTED")}
                  className={`${
                    activeBtn === "POSTED"
                      ? "text-[#2DD683] border border-[#2DD683]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#2DD683]"></span>{" "}
                  Posted
                </button>

               
                
              </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.srId}
                columns={columns}
                dataSource={filterDataList}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: storeRequestCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchStoreRequestData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete ${prodd?.srDescription}?`}
        title={`Delete ${prodd?.srDescription}`}
      />

      <AddStoreRequestModal
        handleFetchData={fetchStoreRequestData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handlePostRequest}
        loading={saving}
        content={`Are you sure you want to post request for ${prodd?.srItemName} `}
      />
    </div>
  );
}
